// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aed2aa40","453":"7430565b","732":"1ef1d280","977":"90476d47"}[chunkId] + ".chunk.js";
};